import { createTheme }            from '@mui/material/styles'
import { variables }              from './variables'

const FONT = "Ubuntu, Arial"

export default createTheme({
  palette: {
    mode: 'dark',
    common: {
      black: variables.black,
      white: variables.white,
      textHeading: variables.textHeading,
    },
    primary: {
      main: variables.primary,
      dark: variables.dark,
      contrastText: variables.white,
    },
    secondary: {
      main: variables.dark,
      contrastText: variables.white,
    },
    text: {
      primary: variables.textPrimary,
      secondary: variables.textSecondary,
    },
    divider: variables.divider,

    background: {
      default: variables.black,
      paper: variables.darker,
    },
    error: {
      main: variables.error,
    },
    warning: {
      main: variables.warning,
    },
  },
  typography: {
    htmlFontSize: 10,
    fontFamily: FONT,

    xxs: variables.xxs,
    xs: variables.xs,
    sm: variables.sm,
    md: variables.md,
    lg: variables.lg,
    xl: variables.xl,
    xxl: variables.xxl,

    h1: {
      fontFamily: FONT,
      fontSize: variables.xxl,
      fontWeight: 'bold',
    },
    h2: {
      fontFamily: FONT,
      fontSize: variables.xl,
      fontWeight: 'bold',
    },
    h3: {
      fontFamily: FONT,
      fontSize: variables.lg,
      fontWeight: 'bold',
    },
    h4: {
      fontFamily: FONT,
      fontSize: variables.sm,
      fontWeight: 'bold',
    },
    subtitle1: {
      fontFamily: FONT,
      fontSize: variables.sm,
      fontWeight: 400,
      lineHeight: 1.4,
    },
    subtitle2: {
      fontFamily: FONT,
      fontSize: variables.xs,
      fontWeight: 500,
      lineHeight: 1.3,
    },
    body1: {
      fontFamily: FONT,
      fontSize: variables.sm,
      fontWeight: 400,
    },
    body2: {
      fontFamily: FONT,
      fontSize: variables.sm,
      fontWeight: 400,
    },
    button: {
      fontFamily: FONT,
      fontSize: 'inherit',
      fontWeight: 'bold',
      textTransform: 'capitalize',
    },
    caption: {
      fontFamily: FONT,
      fontSize: variables.xxs,
      fontWeight: 400,
      lineHeight: 1.5,
    },
  }
})